<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="warehouseOrder">
      <div class="wrap">
        <div class="main">
          <main class="main__content">
            <div class="section section--shipping-address">

              <!-- customer information start-->
              <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                <div class="title">
                  <span>{{ $t("importmso") }}</span>
                </div>
                <div class="fieldset">
                  <span>{{ $t("step1") }}</span>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <button class="btn" @click="downloadMSO" href={exportUrl}>
                        <i class="el-icon-download"></i><span> {{ $t("downloadTemplate") }}</span>
                      </button>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="2">
                    </el-col>
                  </el-row>
                  <span>{{ $t("step2") }}</span>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-upload
                        :multiple="false"
                        :limit="10"
                        action=""
                        :on-remove="handleFileRemove"
                        :before-remove="beforeFileRemove"
                        :on-change="handleFileImport"
                        :auto-upload="false">
                        <button class="btn">
                          <i class="el-icon-document"></i><span> {{ $t("selectFile") }}</span>
                        </button>
                      </el-upload> 
                    </el-col>
                  </el-row>
                  <span>{{ $t("step3") }}</span>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <button class="btn" @click="uploadMSO">
                        <span> {{ $t("submit") }}</span>
                      </button>
                    </el-col>
                  </el-row>
                </div>
                <!-- end customer information -->
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions} from "vuex";
  import {Alert} from "element-ui";
  import axios from "axios";
  import breadcrumb from "../../components/breadcrumb";
  import addresses from "../../store/modules/addresses";


  export default {
    name: "mso",
    components: {
      breadcrumb,
    },
    data() {
      return {
        path2: this.$t("importmso"),
        file: [],
      };
    },
    computed: mapState({
    }),
    methods: {
      downloadMSO() {
        const url = 'https://ying-scm.truckxi.com/api/v2/customer-so-template?Bearer=${localStorage.getItem("token")}';
        window.location.href = url;
      },
      // Method for file
      handleFileImport(file, fileList) {
        this.file = fileList;
        // this.updateFileList(fileList, 0); 
      },
      beforeFileRemove(file, fileList) {
        return this.$confirm(`Remove ${ file.name } ?`);
      },
      handleFileRemove(file, fileList) {
        this.file = [];
        // this.updateFileList(fileList, 0);
      },
      uploadMSO() {
        var formData = new FormData();
        formData.append('FILE', this.file[0].raw);
        axios.post(
          `https://ying-scm.truckxi.com/api/v2/import_orders_abcff`,
          formData,
          {
            headers: { Authorization: `JWT ${localStorage.getItem("token")}` },
          }
        )
        .then(
          (res) => {
            alert("MSO Imported Successfully");
          },
          (err) => {
            if (err.data) {
              alert(err.data);
            } else {
              alert("Server issue detected, please contact admin.");
            }
          }
        );
      },
    },
    mounted: function () {
    },
  };
</script>

<style lang="less">
  @import "../../assets/css/warehouseOrder.less";
</style>



// WEBPACK FOOTER //
// src/view/Service/mso.vue